export const range = (left: number, right: number, inclusive: boolean) => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
};
